module.exports = __webpack_public_path__ + "static/media/logos_MEcon SIDP color 21.eb371773.png";